<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useTrainingPlanStore} from "@/stores/Training/TrainingPlan";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        readonly: Boolean,
        notClearable: Boolean,
        multiple: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const trainingPlanStore = useTrainingPlanStore();

        const trainingPlan = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/trainingPlans`).then(response => {
                trainingPlanStore.setTrainingPlans(response.data);
                trainingPlan.value = trainingPlanStore.getMax();
                emit('input', trainingPlan.value);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            trainingPlan.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            trainingPlanStore,
            loading,
            inputColor,
            backgroundColor,
            trainingPlan,
            input,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
                v-model="trainingPlan"
                :items="trainingPlanStore.trainingPlans"
                item-value="id"
                item-text="name"
                outlined
                dense
                :label="label"
                :color="inputColor"
                :background-color="backgroundColor"
                :readonly="readonly"
                :multiple="multiple"
                :loading="loading"
                :clearable="!(readonly || notClearable)"
                @input="input"
                :rules="rules"
                hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>